// The dispatcher console remembers where each tab was scrolled (this browser tab only), so opening a PDF, a trip,
// another tab or app and coming back lands where you were — not at the top.
const KEY = 'tmw-scroll';
export const scroller = () => (typeof document !== 'undefined' && (document.querySelector('main.main-content') || document.scrollingElement)) || null;
const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch { return {}; } };
export function saveSpot(tab, top) {
  try { sessionStorage.setItem(KEY, JSON.stringify({ ...read(), [tab]: Math.max(0, Math.round(top)) })); } catch { /* private mode */ }
}
export const savedSpot = (tab) => read()[tab] || 0;
export function savedTab() { try { return sessionStorage.getItem('tmw-tab') || null; } catch { return null; } }
export function rememberTab(tab) { try { sessionStorage.setItem('tmw-tab', tab); } catch { /* ignore */ } }

// Keep saving the scroll spot of the open tab; when a tab opens, put it back where it was. Content loads after the
// tab opens (trips, cards), so keep trying for a couple of seconds — and stop the moment the person scrolls.
export function trackTab(tab, el = scroller()) {
  if (!el) return () => {};
  const target = savedSpot(tab);
  let restoring = target > 0;
  let t = null;
  let last = target;               // the spot before the tab changed (by cleanup time the new tab's content is already in)
  const stop = () => { restoring = false; };
  const onScroll = () => {
    if (restoring) return;          // a short page clamps the spot while loading — don't save that
    last = el.scrollTop;
    clearTimeout(t); t = setTimeout(() => saveSpot(tab, last), 120);
  };
  const tries = [];
  if (restoring) {
    el.scrollTop = target;
    for (const ms of [60, 200, 450, 800, 1300, 2000, 3000, 4000]) tries.push(setTimeout(() => { if (restoring) el.scrollTop = target; }, ms));
    tries.push(setTimeout(stop, 4100));
  } else el.scrollTop = 0;
  el.addEventListener('scroll', onScroll, { passive: true });
  for (const ev of ['wheel', 'touchstart', 'keydown', 'mousedown']) el.addEventListener(ev, stop, { passive: true });
  return () => {
    tries.forEach(clearTimeout); clearTimeout(t);
    if (!restoring) saveSpot(tab, last);
    el.removeEventListener('scroll', onScroll);
    for (const ev of ['wheel', 'touchstart', 'keydown', 'mousedown']) el.removeEventListener(ev, stop);
  };
}
